import {
  RoleDtoRole,
  UserCreationDtoRoleType,
  type DetailedUserDto,
  type MinimalCustomer,
  type UserCreationDto,
  type UserPatchDtoAttributes,
} from '@/generated/model';

import type { UserAccessFormDirtyFields, UserAccessFormValues } from '../types/UserAccessFormValues';

export function getCreateUserDefaultValues(customer: MinimalCustomer): UserAccessFormValues {
  return {
    username: '',
    phone: '',
    firstName: '',
    surname: '',
    role: RoleDtoRole.simpleUser,
    customer,
    active: false,
  };
}

export function getCreationDto(data: UserAccessFormValues): UserCreationDto {
  return {
    username: data.username,
    surname: data.surname,
    firstName: data.firstName,
    phone: data.phone || undefined,
    role: data.role,
    roleObjectId: data.customer.id,
    roleType: UserCreationDtoRoleType.CUSTOMER,
  };
}

export function getFormValues(data: DetailedUserDto, customers: MinimalCustomer[]): UserAccessFormValues | undefined {
  const role = data.role.role;
  const customer = customers.find(({ id }) => id === data.role.roleObjectId);

  if (!role || !customer) {
    return;
  }

  return {
    username: data.username,
    surname: data.surname ?? '',
    firstName: data.firstName ?? '',
    phone: data.phone,
    role,
    customer,
    active: data.active,
  };
}

export function getPatchAttributes(
  data: UserAccessFormValues,
  dirtyFields: UserAccessFormDirtyFields,
  isSelfService: boolean
): UserPatchDtoAttributes {
  if (isSelfService) {
    return dirtyFields.phone && data.phone !== undefined ? { phone: data.phone } : {};
  }

  const attributes: UserPatchDtoAttributes = {};

  if (dirtyFields.surname) {
    attributes.surname = data.surname;
  }
  if (dirtyFields.firstName) {
    attributes.firstName = data.firstName;
  }
  if (dirtyFields.phone && data.phone !== undefined) {
    attributes.phone = data.phone;
  }
  if (dirtyFields.role) {
    attributes.role = data.role;
  }
  if (dirtyFields.active) {
    attributes.active = String(data.active);
  }
  if (dirtyFields.customer) {
    attributes.roleObjectId = String(data.customer.id);
  }

  return attributes;
}
